<template>
    <div class="footer-content">
        <div class="footer dus-container pt-lg-56 pt-32 pb-0 pb-lg-56">
            <div class="footer-list">
                <p class="title -active">
                    {{ $t("footer.home.title") }}
                </p>
                <ul class="item-1">
                    
                    <li>
                        <a href="/store">{{ $t("footer.home.store")}}</a>
                    </li>
                    <li>
                        <a href="/partners">{{ $t("footer.home.spareparts")}}</a>
                    </li>
                    <li>
                        <a href="/attestation-certificat">{{$t("footer.home.documents") }}</a>
                    </li>
                   
                    <li>
                        <a href="/lexique">{{ $t("footer.home.lexique") }}</a>
                    </li>
                    <li>
                        <a href="/newsletter">{{ $t("footer.home.newsletter") }}</a>
                    </li>
                </ul>
            </div>
            <div class="footer-list">
                <p class="title -active">
                    {{ $t("footer.renault-group.title") }}
                </p>
                <ul class="item-2">
                    <li>
                        <a
                            href="https://theoriginals.renault.com/"
                            target="_blank"
                        >
                            {{ $t("footer.renault-group.museum") }}</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://theoriginals-store.renault.com/"
                            target="_blank"
                        >
                            {{ $t("footer.renault-group.store") }}</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://theoriginals.renault.com/go/site-pays"
                            target="_blank"
                        >
                            {{ $t("footer.renault-group.country") }}</a
                        >
                    </li>
                    <li>
                        <a href="https://src.renault.fr/" target="_blank">
                            {{ $t("footer.renault-group.src") }}</a
                        >
                    </li>
                </ul>
            </div>
            <div class="footer-list">
                <p class="title -active">
                    {{ $t("footer.about.title") }}
                </p>
                <ul class="item-3">
                    <li>
                        <a href="/terms-of-service">{{
                            $t("footer.about.cgv")
                        }}</a>
                    </li>
                    <li>
                        <a
                            :href="
                                currentLang == 'fr'
                                    ? 'https://www.renaultgroup.com/information-sur-la-protection-de-vos-donnees-personnelles/'
                                    : 'https://www.renaultgroup.com/en/information-on-personal-data-protection/'
                            "
                            target="_blank"
                            >{{ $t("footer.about.cgu") }}</a
                        >
                    </li>
                    <li>
                        <a href="/cookies">{{ $t("footer.about.cookies") }}</a>
                    </li>
                    <li>
                        <a href="/legal-mention">{{
                            $t("footer.about.legal")
                        }}</a>
                    </li>
                </ul>
            </div>
            <div class="footer-list">
                <h6 class="title -active">
                    {{ $t("footer.contact.title") }}
                </h6>
                <ul class="item-4">
                    <li>
                        <a href="/faq">{{ $t("footer.contact.mail") }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="copyright">
            <small><span>© Renault 2024</span></small>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        currentLang() {
            return this.$store.state.languages.current;
        },
    },
};
</script>

